/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_TitleInputs */

const en_mk_tut_tr_title = /** @type {(inputs: Mk_Tut_Tr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When something does not match`)
};

const id_mk_tut_tr_title = /** @type {(inputs: Mk_Tut_Tr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau ada yang tidak sesuai`)
};

/**
* | output |
* | --- |
* | "When something does not match" |
*
* @param {Mk_Tut_Tr_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_title = /** @type {((inputs?: Mk_Tut_Tr_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_title(inputs)
	return en_mk_tut_tr_title(inputs)
});